const Logo = ({ compact = false }) => (
  <span className="flex items-center" data-testid="brand-logo">
    <img
      src="/assets/logo.png"
      alt="New Boogie Woogie Academy — official logo"
      className={`w-auto rounded-md bg-white object-contain shadow-[0_2px_14px_rgba(0,0,0,0.45)] ${
        compact ? "h-10 px-2.5 py-1.5" : "h-12 px-3 py-1.5"
      }`}
    />
  </span>
);

export default Logo;
